import React, { useState, useEffect } from "react";
import { StoreContext } from "../context/StoreContext";
// prettier-ignore
import { TextField, Box, Button, Grid, FormControl, Typography, Snackbar, InputLabel, Select, MenuItem, Switch, FormControlLabel, InputAdornment, CircularProgress, IconButton, ButtonGroup, useTheme, Collapse, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
import ReplayIcon from "@mui/icons-material/Replay";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { ThemeProvider } from "@mui/material/styles";
import { DialogTheme } from "../styles/DialogTheme";
import { usePromotionsStyles } from "../styles/PromotionsFormStyles";
import { graphql, graphqlOperation } from "../modules/AmplifyServices";
import * as mutations from "../graphql/mutations";
import * as queries from "../graphql/queries";
import { getCurrencySymbol } from "../utils";
import { serviceTypeByCompanyCustom } from "../queries/ProviderFormQueries";
import { auditPackagesCreate, auditPackagesUpdate } from "../modules/Audit";
import { getUserFromCache } from "../user/UserCommon";
import { MB_SERVICE_CLASSIFICATION_GROUP } from "../utils/Constants";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
    eachDayOfInterval,
    getDay,
    format as formatDate,
    addMonths
} from "date-fns";
import { daysMonFirst } from "../atoms/recurringSettings";
import InfoTooltip from "../utils/UI/InfoTooltip";

export default function PackageAddEditForm({ open, onClose, mode, packageId, serviceId }) {
    const { state, dispatch, actions } = React.useContext(StoreContext);
    // snackbar
    const [msgOpen, setMsgOpen] = React.useState(false);
    const [snackMsg, setSnackMsg] = React.useState();
    //fields
    const [description, setDescription] = React.useState("");
    const [quantity, setQuantity] = React.useState("");
    const [price, setPrice] = React.useState("0");
    const [discount, setDiscount] = useState("");
    const [createdAt, setCreatedAt] = React.useState();
    const [serviceTypeData, setServiceTypeData] = useState();
    const [packageType, setPackageType] = useState("DOLLAR");
    const [oldInfo, setOldInfo] = useState([]);
    const [active, setActive] = React.useState(true);
    const classesnew = usePromotionsStyles();
    //type
    const [values, setValues] = React.useState({
        type: ""
    });
    //Fetching user info from cache.
    const loggedInUser = getUserFromCache();
    console.log(loggedInUser, "UserObj");
    // tracks if fields are blurred in order to generate description
    const [isBlurred, setisBlurred] = useState({
        price: true,
        discount: true,
        quantity: true
    });

    const [disableSave, setDisableSave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Subscription schedule state
    const theme = useTheme();
    const [subscriptionEnabled, setSubscriptionEnabled] = useState(false);
    const [subscriptionStartDate, setSubscriptionStartDate] = useState(
        new Date()
    );
    const [subscriptionEndDate, setSubscriptionEndDate] = useState(
        addMonths(new Date(), 3)
    );
    const [selectedDays, setSelectedDays] = useState([]);
    const [sessionDates, setSessionDates] = useState([]);
    const [excludedDates, setExcludedDates] = useState([]);
    const [rrule, setRrule] = useState("");
    const [expandedMonths, setExpandedMonths] = useState({});

    // Track initial state for RefData cleanup on save
    const [initialSubscriptionEnabled, setInitialSubscriptionEnabled] =
        useState(false);
    const [initialServiceId, setInitialServiceId] = useState(null);

    // Map JS getDay() indices to RRULE day abbreviations
    const rruleDayMap = {
        0: "SU",
        1: "MO",
        2: "TU",
        3: "WE",
        4: "TH",
        5: "FR",
        6: "SA"
    };

    // Compute session dates when subscription settings change
    useEffect(() => {
        if (
            subscriptionEnabled &&
            subscriptionStartDate &&
            subscriptionEndDate &&
            selectedDays.length > 0
        ) {
            try {
                const allDays = eachDayOfInterval({
                    start: subscriptionStartDate,
                    end: subscriptionEndDate
                });
                const matchingDays = allDays.filter((day) =>
                    selectedDays.includes(getDay(day))
                );
                setSessionDates(matchingDays);
                // Remove any excluded dates that no longer exist in the new range
                setExcludedDates((prev) =>
                    prev.filter((exDate) =>
                        matchingDays.some(
                            (d) => d.getTime() === exDate.getTime()
                        )
                    )
                );
            } catch (e) {
                setSessionDates([]);
            }
        } else if (subscriptionEnabled) {
            setSessionDates([]);
            if (selectedDays.length === 0) setQuantity(0);
        }
    }, [
        subscriptionEnabled,
        subscriptionStartDate,
        subscriptionEndDate,
        selectedDays
    ]);

    // Update RRULE and quantity whenever sessions or exclusions change
    useEffect(() => {
        if (!subscriptionEnabled || sessionDates.length === 0) {
            setRrule("");
            return;
        }
        const activeCount = sessionDates.length - excludedDates.length;
        setQuantity(activeCount);

        const byDay = selectedDays
            .sort((a, b) => a - b)
            .map((d) => rruleDayMap[d])
            .join(",");
        const until = formatDate(
            subscriptionEndDate,
            "yyyyMMdd'T'235959'Z'"
        );
        let rule = `RRULE:FREQ=WEEKLY;BYDAY=${byDay};UNTIL=${until}`;
        if (excludedDates.length > 0) {
            const exdates = excludedDates
                .sort((a, b) => a - b)
                .map((d) => formatDate(d, "yyyyMMdd"))
                .join(",");
            rule += `\nEXDATE:${exdates}`;
        }
        setRrule(rule);
    }, [sessionDates, excludedDates, subscriptionEnabled]);

    const handleSubscriptionToggle = (event) => {
        const enabled = event.target.checked;
        setSubscriptionEnabled(enabled);
        if (!enabled) {
            setQuantity("");
            setSessionDates([]);
            setSelectedDays([]);
            setExcludedDates([]);
            setRrule("");
            setExpandedMonths({});
        }
    };

    const toggleMonth = (monthKey) => {
        setExpandedMonths((prev) => ({
            ...prev,
            [monthKey]: !prev[monthKey]
        }));
    };

    const excludeDate = (date) => {
        setExcludedDates((prev) => [...prev, date]);
    };

    const restoreDate = (date) => {
        setExcludedDates((prev) =>
            prev.filter((d) => d.getTime() !== date.getTime())
        );
    };

    const isExcluded = (date) => {
        return excludedDates.some((d) => d.getTime() === date.getTime());
    };

    // Group session dates by month for organized display
    const groupDatesByMonth = (dates) => {
        const groups = {};
        dates.forEach((date) => {
            const key = formatDate(date, "yyyy-MM");
            if (!groups[key]) {
                groups[key] = {
                    label: formatDate(date, "MMMM yyyy"),
                    dates: []
                };
            }
            groups[key].dates.push(date);
        });
        return Object.entries(groups).sort(([a], [b]) => a.localeCompare(b));
    };

    const handleDayToggle = (dayIndex) => {
        setSelectedDays((prev) => {
            if (prev.includes(dayIndex)) {
                return prev.filter((d) => d !== dayIndex);
            }
            return [...prev, dayIndex];
        });
    };

    const daysStyleFunction = (val) => {
        return {
            width: 36,
            height: 36,
            borderRadius: "50%",
            backgroundColor: val ? "primary.main" : "white",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: val ? "primary.main" : "rgb(0,0,0,0.23)",
            minWidth: 0,
            color: val ? "white" : "primary.main",
            "&:hover": {
                backgroundColor: "primary.main",
                borderColor: "primary.main",
                color: "white"
            },
            "&.Mui-disabled": {
                borderColor: theme.palette.text.disabled
            }
        };
    };

    const fetchServiceTypes = async () => {
        const loggedInUser = getUserFromCache();

        const filter = {
            and: [
                { active: { ne: false } },
                { deleted: { ne: true } },
                { isVisible: { ne: false } },
                {
                    Classification: {
                        ne: MB_SERVICE_CLASSIFICATION_GROUP
                    }
                }
            ]
        };

        let serviceTypeItems = [];
        let nextToken = null;
        do {
            let serviceTypes = await graphql(
                graphqlOperation(serviceTypeByCompanyCustom, {
                    companyId: loggedInUser.company.id,
                    limit: process.env.REACT_APP_LISTLIMIT,
                    filter,
                    nextToken
                })
            );
            if (serviceTypes?.data?.serviceTypeByCompany) {
                serviceTypeItems.push(
                    ...serviceTypes.data.serviceTypeByCompany.items
                );
                nextToken = serviceTypes.data.serviceTypeByCompany.nextToken ?? null;
            } else {
                nextToken = null;
            }
        } while (nextToken);
        setServiceTypeData(serviceTypeItems);
    };

    useEffect(() => {
        if (!open) return;
        reset();
        fetchServiceTypes();
        if (mode === "Edit" && packageId) {
            setIsLoading(true);
            getPackageData().finally(() => setIsLoading(false));
        }
    }, [open, mode, packageId]);

    async function getPackageData() {
        if (!!packageId) {
            const companyId = loggedInUser.company.id;

            // Fetch package and RefData in parallel
            const promises = [
                graphql(
                    graphqlOperation(queries.getPackage, { id: packageId })
                )
            ];

            // If we have the serviceId, we can fetch RefData in parallel
            if (serviceId) {
                promises.push(
                    graphql(
                        graphqlOperation(queries.getRefData, {
                            refType: `scheduled-package|${companyId}`,
                            refName: `SERVICE#${serviceId}|PACKAGE#${packageId}`
                        })
                    ).catch(() => null)
                );
            }

            const [result, refDataResult] = await Promise.all(promises);
            console.log("getPackageData", result);

            if (!result.data.getPackage) {
                onClose();
                return;
            }

            if (!!result.errors && result.errors.length > 0) return;

            const {
                price,
                discount,
                servicetype,
                packagetype,
                active,
                createdAt,
                desc,
                quantity
            } = result.data.getPackage;
            setPrice(price);
            setDiscount(discount);
            setPackageType(packagetype);
            setActive(active);
            setCreatedAt(createdAt);
            setDescription(desc);
            setValues((oldValues) => ({
                ...oldValues,
                type: servicetype.id
            }));
            setQuantity(quantity);

            setInitialServiceId(servicetype.id);

            oldInfo.push({
                servicetype: servicetype.name,
                packagetype: packagetype,
                price: price,
                discount: discount,
                quantity: quantity,
                desc: desc,
                active: active
            });

            // If we didn't have serviceId upfront, fetch RefData now
            let refData = refDataResult?.data?.getRefData;
            if (!serviceId && !refData) {
                try {
                    const fallback = await graphql(
                        graphqlOperation(queries.getRefData, {
                            refType: `scheduled-package|${companyId}`,
                            refName: `SERVICE#${servicetype.id}|PACKAGE#${packageId}`
                        })
                    );
                    refData = fallback?.data?.getRefData;
                } catch (e) {
                    console.log("No scheduled-package RefData found", e);
                }
            }

            // Populate subscription schedule from RefData
            if (refData && refData.overrideValue) {
                const scheduleData = JSON.parse(refData.overrideValue);
                setInitialSubscriptionEnabled(true);
                setSubscriptionEnabled(true);
                setSubscriptionStartDate(
                    new Date(scheduleData.startDate)
                );
                setSubscriptionEndDate(
                    new Date(scheduleData.endDate)
                );

                // Parse selected days from RRULE
                const rruleStr = scheduleData.rrule || "";
                const byDayMatch = rruleStr.match(/BYDAY=([^;]+)/);
                if (byDayMatch) {
                    const dayAbbrevToIndex = {
                        SU: 0,
                        MO: 1,
                        TU: 2,
                        WE: 3,
                        TH: 4,
                        FR: 5,
                        SA: 6
                    };
                    const days = byDayMatch[1]
                        .split(",")
                        .map((d) => dayAbbrevToIndex[d])
                        .filter((d) => d !== undefined);
                    setSelectedDays(days);
                }

                // Parse excluded dates from EXDATE
                const exdateStr = scheduleData.exdate || "";
                if (exdateStr.startsWith("EXDATE:")) {
                    const dateStrs = exdateStr
                        .replace("EXDATE:", "")
                        .split(",");
                    const exDates = dateStrs
                        .map((ds) => {
                            const y = ds.substring(0, 4);
                            const m = ds.substring(4, 6);
                            const d = ds.substring(6, 8);
                            return new Date(
                                parseInt(y),
                                parseInt(m) - 1,
                                parseInt(d)
                            );
                        })
                        .filter((d) => !isNaN(d.getTime()));
                    setExcludedDates(exDates);
                }
            }
        } else {
            onClose();
        }
    }

    function handleCancelPackageForm() {
        onClose();
    }

    async function savePackage() {
        try {
            let input = {
                packageCompanyId: loggedInUser && loggedInUser.company.id,
                companyId: loggedInUser && loggedInUser.company.id,
                price: price === "" ? 0 : price,
                discount: discount === "" ? 0 : discount,
                packageServicetypeId: values.type,
                servicetypeId: values.type,
                desc: description,
                active: active,
                quantity: quantity,
                packagetype: packageType
            };
            let response;
            if (mode === "Edit") {
                input.id = packageId;
                input.createdAt = createdAt;
                response = await graphql(
                    graphqlOperation(mutations.updatePackage, { input })
                );

                await auditPackagesUpdate(
                    loggedInUser,
                    response.data.updatePackage,
                    newInfo
                );
            } else {
                input.createdAt = new Date();
                response = await graphql(
                    graphqlOperation(mutations.createPackage, { input })
                );

                await auditPackagesCreate(
                    loggedInUser,
                    response.data.createPackage
                );
            }

            if (response && response.data) {
                const savedPackage =
                    mode === "Edit"
                        ? response.data.updatePackage
                        : response.data.createPackage;

                // Handle RefData for scheduled packages
                if (subscriptionEnabled && savedPackage) {
                    // If service type changed and there was an old RefData, delete the old one first
                    if (
                        mode === "Edit" &&
                        initialSubscriptionEnabled &&
                        initialServiceId &&
                        initialServiceId !== values.type
                    ) {
                        await deleteScheduledPackageRefData(initialServiceId);
                    }
                    // Save/create RefData with the current service type
                    await saveScheduledPackageRefData(
                        savedPackage.id,
                        values.type
                    );
                } else if (
                    !subscriptionEnabled &&
                    mode === "Edit" &&
                    initialSubscriptionEnabled
                ) {
                    // Subscription was turned off — delete the old RefData
                    const svcIdForDelete =
                        initialServiceId || serviceId || values.type;
                    await deleteScheduledPackageRefData(svcIdForDelete);
                }

                setSnackMsg("Package saved successfully.");
                onClose();
                setMsgOpen(true);
            } else {
                setSnackMsg("Unable to save the package.");
                setMsgOpen(true);
            }
        } catch (error) {
            console.error(
                "An error occurred saving the package. The error was: "
            );
            console.error(error);
            setDisableSave(false);
        }
    }

    async function saveScheduledPackageRefData(pkgId, serviceId) {
        const companyId = loggedInUser.company.id;
        const refType = `scheduled-package|${companyId}`;
        const refName = `SERVICE#${serviceId}|PACKAGE#${pkgId}`;

        // Split rrule string into RRULE and EXDATE parts
        const rruleParts = rrule.split("\n");
        const rrulePart = rruleParts.find((p) => p.startsWith("RRULE:")) || "";
        const exdatePart =
            rruleParts.find((p) => p.startsWith("EXDATE:")) || "";

        const overrideValue = JSON.stringify({
            rrule: rrulePart,
            exdate: exdatePart,
            startDate: subscriptionStartDate.toISOString(),
            endDate: subscriptionEndDate.toISOString()
        });

        // Check if record already exists
        const existing = await graphql(
            graphqlOperation(queries.getRefData, { refType, refName })
        );

        if (existing.data.getRefData) {
            await graphql(
                graphqlOperation(mutations.updateRefData, {
                    input: {
                        refType,
                        refName,
                        refValue: "scheduled-package",
                        overrideValue
                    }
                })
            );
        } else {
            await graphql(
                graphqlOperation(mutations.createRefData, {
                    input: {
                        refType,
                        refName,
                        refValue: "scheduled-package",
                        overrideValue
                    }
                })
            );
        }
    }

    async function deleteScheduledPackageRefData(serviceId) {
        const companyId = loggedInUser.company.id;
        const refType = `scheduled-package|${companyId}`;
        const refName = `SERVICE#${serviceId}|PACKAGE#${packageId}`;

        try {
            const existing = await graphql(
                graphqlOperation(queries.getRefData, { refType, refName })
            );
            if (existing.data.getRefData) {
                await graphql(
                    graphqlOperation(mutations.deleteRefData, {
                        input: { refType, refName }
                    })
                );
            }
        } catch (e) {
            console.log("No scheduled-package RefData to delete", e);
        }
    }

    async function handleToggleActive() {
        const newActive = !active;
        setActive(newActive);
        try {
            const result = await graphql(
                graphqlOperation(mutations.updatePackage, {
                    input: { id: packageId, active: newActive }
                })
            );
            if (result.data?.updatePackage) {
                setSnackMsg(
                    newActive
                        ? "Package activated."
                        : "Package deactivated."
                );
                setMsgOpen(true);
                onClose();
            }
        } catch (e) {
            console.error("Error toggling active state", e);
            setActive(!newActive); // revert on failure
            setSnackMsg("Something went wrong. Please try again.");
            setMsgOpen(true);
        }
    }

    let newInfo;
    async function handleSavePackage() {
        setDisableSave(true);
        let serviceName;
        newInfo = [
            {
                servicetype: "No Change",
                packagetype: "No Change",
                price: "No Change",
                discount: "No Change",
                quantity: "No Change",
                desc: "No Change",
                active: "No Change"
            }
        ];

        // validate
        if (values.type === 0 || values.type === "") {
            setSnackMsg("Please specify a service type");
            setMsgOpen(true);
            setDisableSave(false);
            return;
        } else {
            serviceName = serviceTypeData.filter((item) => {
                return values.type === item.id;
            });
        }

        if (!packageType) {
            setSnackMsg("Please select a package type.");
            setMsgOpen(true);
            setDisableSave(false);
            return;
        }

        if (showPackageType() && (price === "" || price === null)) {
            setSnackMsg("Please enter a price for the package.");
            setMsgOpen(true);
            setDisableSave(false);
            return;
        }

        if (!showPackageType() && (discount === "" || discount === null)) {
            setSnackMsg("Please enter a discount for the package.");
            setMsgOpen(true);
            setDisableSave(false);
            return;
        }

        if (subscriptionEnabled && selectedDays.length === 0) {
            setSnackMsg(
                "Please select at least one day of the week for the subscription schedule."
            );
            setMsgOpen(true);
            setDisableSave(false);
            return;
        }

        if (
            subscriptionEnabled &&
            (!subscriptionStartDate || !subscriptionEndDate)
        ) {
            setSnackMsg(
                "Please set start and end dates for the subscription schedule."
            );
            setMsgOpen(true);
            setDisableSave(false);
            return;
        }

        if (quantity === "" || quantity == 0) {
            setSnackMsg(
                subscriptionEnabled
                    ? "No sessions found in the selected date range. Please adjust your schedule."
                    : "Please enter a quantity for the package."
            );
            setMsgOpen(true);
            setDisableSave(false);
            return;
        }

        if (description === "") {
            setSnackMsg("Please enter a description for the package.");
            setMsgOpen(true);
            setDisableSave(false);
            return;
        }

        // check to see if any info was updated
        if (mode === "Edit" && oldInfo.length > 0) {
            if (
                serviceName &&
                serviceName[0] &&
                oldInfo[0].servicetype != serviceName[0].name
            ) {
                newInfo.map((item) => {
                    item.servicetype = serviceName[0].name;
                });
            }

            if (oldInfo[0].packagetype != packageType) {
                newInfo.map((item) => {
                    item.packagetype = packageType;
                });
            }

            if (oldInfo[0].price != price) {
                newInfo.map((item) => {
                    item.price = price;
                });
            }

            if (oldInfo[0].discount != discount) {
                newInfo.map((item) => {
                    item.discount = discount;
                });
            }

            if (oldInfo[0].quantity != quantity) {
                newInfo.map((item) => {
                    item.quantity = quantity;
                });
            }

            if (oldInfo[0].desc != description) {
                newInfo.map((item) => {
                    item.desc = description;
                });
            }

            if (oldInfo[0].active != active) {
                newInfo.map((item) => {
                    item.active = active;
                });
            }
        }

        console.log("just a test", newInfo);

        savePackage();
    }

    function showPackageType() {
        if (packageType === "DOLLAR") return true;
        else if (packageType === "PERCENTAGE") return false;
    }

    useEffect(() => {
        if (!packageType && price > 0) {
            // for packages defined prior to introduction of packagetype - default to fixed price
            setPackageType("DOLLAR");
        }
    });

    useEffect(() => {
        // if all required fields are blurred and there is no description, then generate description
        if (
            !description &&
            isBlurred.quantity &&
            ((packageType === "DOLLAR" && isBlurred.price) ||
                (packageType === "PERCENTAGE" && isBlurred.discount))
        ) {
            generateDescription();
        }
    }, [isBlurred]);

    function generateDescription() {
        let value = showPackageType() ? price : discount;
        let session = quantity == 1 ? "SESSION" : "SESSIONS";
        // if all required values are not null, set the new description
        if (value !== "" && quantity !== "" && quantity != 0) {
            setDescription(
                showPackageType()
                    ? `${quantity} ${session} AT ${getCurrencySymbol()}${(
                          price / quantity
                      ).toFixed(2)} PER SESSION`
                    : `${quantity} ${session} AT [price] PER SESSION - SAVE ${discount}%!`
            );
        }
    }

    function handleMsgClose(event, reason) {
        setMsgOpen(false);
    }
    function reset() {
        // reset fields
        setPackageType("DOLLAR");
        setDescription("");
        setPrice("0");
        setDiscount("");
        setQuantity("");
        setActive(true);
        setValues({ type: "" });
        setCreatedAt(undefined);
        setOldInfo([]);
        setDisableSave(false);
        setSubscriptionEnabled(false);
        setSubscriptionStartDate(new Date());
        setSubscriptionEndDate(addMonths(new Date(), 3));
        setSelectedDays([]);
        setSessionDates([]);
        setExcludedDates([]);
        setRrule("");
        setExpandedMonths({});
        setInitialSubscriptionEnabled(false);
        setInitialServiceId(null);
    }
    // handle desc change
    const handleChangeDescription = (e) => {
        setDescription(e.target.value);
    };
    // handle price change
    const handleChangePrice = (e) => {
        if (e.target.value >= 0) {
            setDiscount("");
            setPrice(e.target.value);
        }
    };
    // handle quantity change
    const handleChangeQuantity = (e) => {
        if (e.target.value >= 0) {
            setQuantity(e.target.value);
        }
    };
    // handle discount change
    const handleChangeDiscount = (e) => {
        if (e.target.value >= 0 && e.target.value <= 100) {
            setPrice("");
            setDiscount(e.target.value);
        }
    };
    // handle select change for package
    function handleTypeChange(event) {
        setValues((oldValues) => ({
            ...oldValues,
            [event.target.name]: event.target.value
        }));
    }
    // handle select change for package type
    function handleChangePackageType(event) {
        setPackageType(event.target.value);
    }

    const handleFocus = (e) => {
        if (e.target.id === "price") {
            setisBlurred({ ...isBlurred, price: false });
        } else if (e.target.id === "discount") {
            setisBlurred({ ...isBlurred, discount: false });
        } else if (e.target.id === "quantity") {
            setisBlurred({ ...isBlurred, quantity: false });
        }
    };

    const handleBlur = (e) => {
        if (e.target.id === "price") {
            setisBlurred({ ...isBlurred, price: true });
        } else if (e.target.id === "discount") {
            setisBlurred({ ...isBlurred, discount: true });
        } else if (e.target.id === "quantity") {
            setisBlurred({ ...isBlurred, quantity: true });
        }
    };

    return (
        <ThemeProvider theme={DialogTheme(theme)}>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                open={msgOpen}
                autoHideDuration={3000}
                onClose={handleMsgClose}
                ContentProps={{
                    "aria-describedby": "message-id"
                }}
                message={<span id="message-id">{snackMsg}</span>}
            />
            <Dialog maxWidth="md" fullWidth open={open} onClose={onClose}>
                <DialogTitle sx={{ paddingBottom: "18px !important" }}>{mode === "Edit" ? "Edit Package" : "Add Package"}</DialogTitle>
                <DialogContent>
                    {isLoading ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: 200
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (<>
                    {/* Fixed Day & Time Package toggle */}
                    <Grid container item spacing={2} sx={{ mb: 1 }}>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={subscriptionEnabled}
                                        onChange={handleSubscriptionToggle}
                                        disableRipple
                                        color="primary"
                                        inputProps={{
                                            "aria-label":
                                                "fixed day and time package toggle"
                                        }}
                                    />
                                }
                                label={
                                    <span>
                                        Fixed day and time package
                                        <span style={{ paddingLeft: 8 }}>
                                            <InfoTooltip title="Use this package type when you want the sessions to occur on set days within a date range. Client picks a time which remains fixed for all dates in this package" />
                                        </span>
                                    </span>
                                }
                            />
                        </Grid>
                    </Grid>

                    {/* Service Type - own row, half width */}
                    <Grid container item spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel
                                    id="select-service-type-label"
                                    size="small"
                                    shrink
                                >
                                    Service type *
                                </InputLabel>
                                <Select
                                    labelId="select-service-type-label"
                                    id="select-service-type"
                                    value={values.type}
                                    onChange={handleTypeChange}
                                    name="type"
                                    label="Service type *"
                                    notched
                                >
                                    {serviceTypeData &&
                                        serviceTypeData.length > 0 &&
                                        serviceTypeData.map((item, i) => (
                                            <MenuItem value={item.id} key={i}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* Package Type & Price/Discount - same row */}
                    <Grid container item spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <FormControl sx={{ flex: 1 }}>
                                    <InputLabel
                                        id="select-package-type-label"
                                        size="small"
                                        shrink
                                    >
                                        Package type *
                                    </InputLabel>
                                    <Select
                                        labelId="select-package-type-label"
                                        id="select-package-type"
                                        value={packageType}
                                        onChange={handleChangePackageType}
                                        label="Package type *"
                                        notched
                                    >
                                        <MenuItem value={"DOLLAR"}>Dollar</MenuItem>
                                        <MenuItem value={"PERCENTAGE"}>
                                            Percentage
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <InfoTooltip title={packageType === "PERCENTAGE" ? "Package price is determined by the single unit service price chosen under Services, multiplied by the quantity chosen here. Discount applied if you want to offer a quantity discount." : "Package price is determined here, overrides pricing chosen on Services page."} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                {showPackageType() ? (
                                    <TextField
                                        id="price"
                                        label="Price"
                                        type="number"
                                        size="small"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                    disableTypography
                                                >
                                                    {getCurrencySymbol()}
                                                </InputAdornment>
                                            )
                                        }}
                                        value={price}
                                        onChange={handleChangePrice}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                    />
                                ) : (
                                    <TextField
                                        id="discount"
                                        label="Discount"
                                        type="number"
                                        size="small"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    disableTypography
                                                >
                                                    %
                                                </InputAdornment>
                                            )
                                        }}
                                        value={discount}
                                        onChange={handleChangeDiscount}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                    />
                                )}
                        </Grid>
                    </Grid>


                    {/* Subscription schedule UI */}
                    {subscriptionEnabled && (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid container item spacing={2}>
                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            border: "1px solid",
                                            borderColor: "divider",
                                            borderRadius: 2,
                                            p: 2.5
                                        }}
                                    >
                                        {/* Date Range Row */}
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    label="Start Date"
                                                    value={subscriptionStartDate}
                                                    onChange={(date) =>
                                                        setSubscriptionStartDate(date)
                                                    }
                                                    minDate={new Date()}
                                                    inputFormat="MMM dd, yyyy"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    label="End Date"
                                                    value={subscriptionEndDate}
                                                    onChange={(date) =>
                                                        setSubscriptionEndDate(date)
                                                    }
                                                    minDate={subscriptionStartDate}
                                                    inputFormat="MMM dd, yyyy"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* Day Selector */}
                                        <Box sx={{ mt: 2.5 }}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    mb: 1.5,
                                                    color: "text.secondary",
                                                    fontWeight: 500
                                                }}
                                            >
                                                Repeat on
                                            </Typography>
                                            <ButtonGroup
                                                sx={{
                                                    display: "flex",
                                                    gap: "8px"
                                                }}
                                            >
                                                {daysMonFirst.map((day) => (
                                                    <IconButton
                                                        key={day.id}
                                                        onClick={() =>
                                                            handleDayToggle(day.id)
                                                        }
                                                        sx={daysStyleFunction(
                                                            selectedDays.includes(day.id)
                                                        )}
                                                    >
                                                        <Box
                                                            sx={{
                                                                fontSize: "14px",
                                                                fontWeight: "500",
                                                                fontFamily: "roboto"
                                                            }}
                                                        >
                                                            {day.title}
                                                        </Box>
                                                    </IconButton>
                                                ))}
                                            </ButtonGroup>
                                        </Box>

                                        {/* Sessions list */}
                                        {sessionDates.length > 0 && (
                                            <Box sx={{ mt: 2.5 }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        mb: 1.5
                                                    }}
                                                >
                                                    <CalendarTodayIcon
                                                        sx={{
                                                            fontSize: 18,
                                                            color: "primary.main"
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="subtitle2"
                                                        sx={{ fontWeight: 600 }}
                                                    >
                                                        {sessionDates.length -
                                                            excludedDates.length}{" "}
                                                        session
                                                        {sessionDates.length -
                                                            excludedDates.length !==
                                                        1
                                                            ? "s"
                                                            : ""}
                                                    </Typography>
                                                    {excludedDates.length > 0 && (
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                color: "text.secondary"
                                                            }}
                                                        >
                                                            ({excludedDates.length}{" "}
                                                            excluded)
                                                        </Typography>
                                                    )}
                                                </Box>

                                                <Box
                                                    sx={{
                                                        maxHeight: 350,
                                                        overflowY: "auto",
                                                        border: "1px solid",
                                                        borderColor: "divider",
                                                        borderRadius: 1
                                                    }}
                                                >
                                                    {groupDatesByMonth(sessionDates).map(
                                                        ([monthKey, group]) => {
                                                            const activeInMonth =
                                                                group.dates.filter(
                                                                    (d) => !isExcluded(d)
                                                                ).length;
                                                            return (
                                                                <Box key={monthKey}>
                                                                    <Box
                                                                        onClick={() =>
                                                                            toggleMonth(
                                                                                monthKey
                                                                            )
                                                                        }
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "space-between",
                                                                            px: 2,
                                                                            py: 0.75,
                                                                            backgroundColor: "grey.100",
                                                                            borderBottom: "1px solid",
                                                                            borderColor: "divider",
                                                                            cursor: "pointer",
                                                                            userSelect: "none",
                                                                            "&:hover": {
                                                                                backgroundColor: "grey.200"
                                                                            }
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="caption"
                                                                            sx={{
                                                                                fontWeight: 600,
                                                                                textTransform: "uppercase",
                                                                                letterSpacing: 0.5,
                                                                                color: "text.secondary"
                                                                            }}
                                                                        >
                                                                            {group.label}
                                                                        </Typography>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                gap: 0.5
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                variant="caption"
                                                                                sx={{ color: "text.secondary" }}
                                                                            >
                                                                                {activeInMonth} session
                                                                                {activeInMonth !== 1 ? "s" : ""}
                                                                            </Typography>
                                                                            {expandedMonths[monthKey] ? (
                                                                                <ExpandLessIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                                                                            ) : (
                                                                                <ExpandMoreIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                                                                            )}
                                                                        </Box>
                                                                    </Box>
                                                                    <Collapse in={expandedMonths[monthKey]}>
                                                                        {group.dates.map((date, i) => {
                                                                            const excluded = isExcluded(date);
                                                                            return (
                                                                                <Box
                                                                                    key={i}
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        px: 2,
                                                                                        py: 0.5,
                                                                                        borderBottom: "1px solid",
                                                                                        borderColor: "divider",
                                                                                        opacity: excluded ? 0.45 : 1,
                                                                                        "&:hover": { backgroundColor: "action.hover" },
                                                                                        "&:last-child": { borderBottom: "none" }
                                                                                    }}
                                                                                >
                                                                                    <Typography
                                                                                        variant="body2"
                                                                                        sx={{
                                                                                            fontWeight: 500,
                                                                                            minWidth: 36,
                                                                                            color: excluded ? "text.disabled" : "primary.main"
                                                                                        }}
                                                                                    >
                                                                                        {formatDate(date, "EEE")}
                                                                                    </Typography>
                                                                                    <Typography
                                                                                        variant="body2"
                                                                                        sx={{
                                                                                            flex: 1,
                                                                                            textDecoration: excluded ? "line-through" : "none",
                                                                                            color: excluded ? "text.disabled" : "text.primary"
                                                                                        }}
                                                                                    >
                                                                                        {formatDate(date, "MMMM d, yyyy")}
                                                                                    </Typography>
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() =>
                                                                                            excluded
                                                                                                ? restoreDate(date)
                                                                                                : excludeDate(date)
                                                                                        }
                                                                                        sx={{ p: 0.5 }}
                                                                                    >
                                                                                        {excluded ? (
                                                                                            <ReplayIcon sx={{ fontSize: 16, color: "primary.main" }} />
                                                                                        ) : (
                                                                                            <CloseIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                                                                                        )}
                                                                                    </IconButton>
                                                                                </Box>
                                                                            );
                                                                        })}
                                                                    </Collapse>
                                                                </Box>
                                                            );
                                                        }
                                                    )}
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>
                        </LocalizationProvider>
                    )}

                    {/* Quantity - half width (only when not subscription) */}
                    {!subscriptionEnabled && (
                        <Grid container item spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="quantity"
                                    label="Quantity *"
                                    type="number"
                                    size="small"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={quantity}
                                    onChange={handleChangeQuantity}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                />
                            </Grid>
                        </Grid>
                    )}

                    {/* Description - full width with embedded text button */}
                    <Grid container item spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{ position: "relative" }}>
                                <TextField
                                    id="description"
                                    label="Description *"
                                    size="small"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    InputLabelProps={{ shrink: true }}
                                    value={description}
                                    onChange={handleChangeDescription}
                                    helperText="This description is client-facing and will be shown when selecting a package"
                                    FormHelperTextProps={{ sx: { ml: 0 } }}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            paddingBottom: "28px"
                                        }
                                    }}
                                />
                                <Button
                                    variant="text"
                                    color="primary"
                                    onClick={generateDescription}
                                    disabled={
                                        subscriptionEnabled ||
                                        !packageType ||
                                        !quantity ||
                                        quantity == 0 ||
                                        (showPackageType() &&
                                            price === "") ||
                                        (!showPackageType() &&
                                            discount === "")
                                    }
                                    disableRipple
                                    sx={{
                                        position: "absolute",
                                        bottom: 28,
                                        right: 8,
                                        p: 0,
                                        minWidth: "auto",
                                        "&:hover": {
                                            backgroundColor:
                                                "transparent !important"
                                        }
                                    }}
                                >
                                    <Typography
                                        variant="button"
                                        sx={{
                                            textTransform: "none",
                                            fontSize: "0.75rem",
                                            lineHeight: "14px"
                                        }}
                                    >
                                        Set default description
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Deactivate package - text button (only in Edit mode) */}
                    {mode === "Edit" && (
                        <Grid container item spacing={2}>
                            <Grid item xs={12}>
                                <Button
                                    variant="text"
                                    color="primary"
                                    onClick={handleToggleActive}
                                    disableRipple
                                    sx={{
                                        "&:hover": {
                                            backgroundColor: "transparent !important"
                                        }
                                    }}
                                >
                                    <Typography
                                        variant="button"
                                        sx={{
                                            textTransform: "none",
                                            lineHeight: "14px"
                                        }}
                                    >
                                        {active
                                            ? "Deactivate package"
                                            : "Activate package"}
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                    </>)}
                </DialogContent>
                <DialogActions>
                    <Grid
                        container
                        item
                        gap="18px"
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >
                        <Button
                            onClick={handleCancelPackageForm}
                            variant="cancelButton"
                            disabled={disableSave}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSavePackage}
                            disabled={
                                disableSave ||
                                !values.type ||
                                values.type === 0 ||
                                !packageType ||
                                !description ||
                                (!quantity && !subscriptionEnabled) ||
                                (quantity == 0 && !subscriptionEnabled) ||
                                (subscriptionEnabled &&
                                    (sessionDates.length - excludedDates.length) === 0)
                            }
                        >
                            Save
                            {disableSave && (
                                <CircularProgress
                                    size={24}
                                    className={classesnew.buttonProgress}
                                />
                            )}
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}
